import React from 'react'

import Styles from './styles'
import { PaginationProvider } from './context'
import Pages from './Pages'
import Limit from './Limit'

function Pagination({ totalItems = 0, totalPages = 0, children, prefix }) {
  return (
    <>
      <PaginationProvider
        totalPages={totalPages}
        totalItems={totalItems}
        prefix={prefix}
      >
        <Styles.PaginationWrapper>{children}</Styles.PaginationWrapper>
      </PaginationProvider>
    </>
  )
}

Pagination.Pages = Pages
Pagination.Limit = Limit

export default Pagination
